import { dehydrate } from '@tanstack/react-query'
import { serialize } from 'cookie'

import { getProps } from 'ssr/getProps'
import { WORKSPACE_TAB } from 'ui-components'
import { getWorkspace } from 'user-auth'
import { base64, fromBase64, getWorkspaceLink } from 'utils'

export const getServerSideProps = getProps((context, client, props) => {
  const { user } = props

  if (!user) {
    return {
      props: {
        dehydratedState: dehydrate(client)
      }
    }
  }

  const cached = fromBase64(context.req.cookies['workspace_current'])

  if (cached) {
    const { id, name } = cached

    return {
      redirect: {
        destination: getWorkspaceLink({
          workspaceId: id,
          workspaceName: name,
          tab: WORKSPACE_TAB.MAPS
        }),
        permanent: false
      }
    }
  }

  // prettier-ignore
  const workspace = 
    user
    ?.membershipCollection
    ?.items
    .find(
      (item) => item.workspace.id === user?.defaultWorkspaceId
    )?.workspace

  if (!workspace) {
    return {
      props: {
        dehydratedState: dehydrate(client)
      }
    }
  }

  const cookie = [
    serialize('workspace_current', base64(getWorkspace(workspace)))
  ]

  context.res.setHeader('Set-Cookie', cookie)

  return {
    redirect: {
      destination: getWorkspaceLink({
        workspaceId: workspace.id,
        workspaceName: workspace.name,
        tab: WORKSPACE_TAB.MAPS
      }),
      permanent: false
    }
  }
})
